$(document).ready(function() {
	$('.js-square-modal').on('click', function() {
		$('.js-modal-square').css('top', ($(window).scrollTop()) + "px");
		$('.js-modal-square').show();
	});
	$('.js-modal-square').on('click', function(e) {
		if (!((e.target).closest('.b-modal-square__inner'))) {
			$('.js-modal-square').hide();
		}
	});
	$('.js-modal-square-close').on('click', function() {
		$('.js-modal-square').hide();
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/game-loto/modal-square.js